// Add DOM4 support, https://github.com/WebReflection/dom4
import "dom4";

// jQuery direkt importieren (ins Bundle gepackt)
import $ from "jquery";
window.$ = window.jQuery = $;

// Add Babel polyfill for ES2015, https://babeljs.io/docs/usage/polyfill/
//import "babel-polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";

// Import all components from Audi UI library
import aui from "../../node_modules/@audi/audi-ui";


var theLanguage = $('html').attr('lang');

// custom
import { navigation } from "./navigation";
import { doAjax } from "./helper";
import { initDots } from "./dots";
import { initDisplayToggle } from "./displaytoggle";
import { initCheckBoxesLogic } from "./screen-package-selection-global";
import { checkSeatsAndSteeringWheelBadges_etron } from "./screen-package-selection-etron";
import { checkSeatsAndSteeringWheelBadges_a6limousine } from "./screen-package-selection-a6limousine";
import { checkSeatsAndSteeringWheelBadges_q7 } from "./screen-package-selection-q7";
import { checkSeatsAndSteeringWheelBadges_q8 } from "./screen-package-selection-q8";
import { checkSeatsAndSteeringWheelBadges_rsq8 } from "./screen-package-selection-rsq8";
import { checkSeatsAndSteeringWheelBadges_a8 } from "./screen-package-selection-a8";
import { checkSeatsAndSteeringWheelBadges_q6etron } from "./screen-package-selection-q6etron";
import { checkSeatsAndSteeringWheelBadges_q6etron_s_line } from "./screen-package-selection-q6etron_s_line";
import { checkSeatsAndSteeringWheelBadges_a5 } from "./screen-package-selection-a5";
import { loginLogic } from "./screen-login-logic";
import { initPackageSelectionModal } from "./screen-package-selection-modal";
import { initSeatSelect } from "./screen-seat-select-logic";
import { initSeatCustomizing } from "./screen-seat-logic";
import { initComponentsSeatsCustomizing } from "./screen-seat--components-logic";
import { initLanguageSelector } from "./screen-language-selector-logic";
import { initModelcategorySelectLogic } from "./screen-modelcategory-select-logic";
import { initSummaryAndGeneratePDF, initValidation, saveMetaOnChange } from './screen-pdf-logic';
import { initSteeringWheelCustomizing } from './screen-wheel-logic';
import { initInteriorCustomizing } from './screen-interior-logic';
import { initInteriorFC1Customizing } from './screen-interior-fc1-logic';
import { initInteriorYZ4Customizing } from './screen-interior-leather-yz4-logic';
import { initLeatherCoverSelectLogic } from './screen-leather-covered-seat-logic';
import { initWheelSelectLogic } from "./screen-wheel-select-logic";
import { initModelSelectLogic } from "./screen-model-select-logic";
import { initAirbagSelectLogic } from './screen-airbag-cover-logic';
import { initRSStickungSelectLogic } from './screen-rs-stickung-logic';
import { initRSfootmateSelectLogic } from './screen-rs-footmate-logic';
import { initDecoWoodSelectLogic } from './screen-deco-wood-logic';
import { initSkySelectLogic } from './screen-sky-logic';
import { initBicolorSelectLogic } from './screen-bicolor-logic';
import { initPillowSelectLogic } from './screen-pillow-logic';
import { initInteriorLeatherSelectLogic } from './screen-interior-leather-logic';
import { initInteriorUpperCustomizing } from './screen-interior-upper-logic';
import { initInteriorSeatBeltsCustomizing } from './screen-interior-seatbelts-logic';
import { initInteriorFootmatsCustomizing } from './screen-interior-footmats';
import { initFlipModal } from './flipModal' ;
import { initResetModal } from "./resetModal";
// Initialize all Audi UI components
aui.upgradeAllElements();

// taken from classes/controller/PageController.php
const 
	PAGE_LOGIN = "login",
	PAGE_LANGUAGE_SELECT = "language",
	PAGE_MODELCATEGORY_SELECTION = "modelcategory-select",
	PAGE_MODEL_SELECTION = "car-select",
	PAGE_PACKAGE_SELECTION = "front",
	PAGE_FRONTSEAT_SELECTION = "seat-select",
	PAGE_FRONTSEAT_CONFIGURATION = "seat",
	PAGE_BACKSEAT_CONFIGURATION = "seats--components",
	PAGE_SITZBLENDE_CONFIGURATION = "leather-covered-seat-cover",
	PAGE_WHEEL_SELECTION = "wheel-select",
	PAGE_WHEEL_CONFIGURATION = "wheel",
	PAGE_AIRBAG_CONFIGURATION = "airbag-cover",
	PAGE_RS_STICKUNG_CONFIGURATION = "rs-stickung",
	PAGE_RS_FOOTMATE_CONFIGURATION = "interior-footmat",
	PAGE_DECORATION_WOOD = "deco-wood",
	PAGE_SKY = "sky",
	PAGE_BICOLOR = 'bicolor',
	PAGE_PILLOW = 'pillow',
	PAGE_INTERIOR_LEATHER = "interior-leather",
	PAGE_INTERIOR = "interior",
	PAGE_INTERIOR_FC1 = "interior--fc1",
	PAGE_INTERIOR_LEATHER_YZ4 = 'interior-leather--yz4', 
	PAGE_INTERIOR_UPPER = "interior--upper",
	PAGE_INTERIOR_SEATBELTS = "interior--seatbelts",
	PAGE_INTERIOR_FOOTMAT = "interior--footmat",
	PAGE_PDF = "pdf";

document.addEventListener("DOMContentLoaded", () => {
	document.getElementById("form")?.addEventListener("submit", (e) => {
		e.preventDefault();
		let params = {};
		for (let pair of new FormData(e.target)) {
			params[pair[0]] = pair[1];
		}
		doAjax(params, (response) => {
			if (response?.success) {
				document.getElementById('loading-screen').classList.add('loading')
				location.href = location.href;
			}
			if (response?.loginError) {
				if (response.loginError == 'wrongPassword'){
					document.getElementById("password-div")
						.classList.add("is-invalid");
				}else{
					document.getElementById("password-div")
						.classList.remove("is-invalid");
				}
				if (response.loginError == 'wrongDealerNumber'){
					document.getElementById("dealer-number-div")
						.classList.add("is-invalid");
				}else{
					document.getElementById("dealer-number-div")
						.classList.remove("is-invalid");
				}
			} else if (response?.apiError) {
				if (response.apiError == 'wrongApiResponse'){
					document.getElementById("api-div")
						.classList.add("is-invalid");
				}
			}
		});
	});
	//Needs to init on evey template
	initFlipModal();

	//move as required
	initResetModal();


	switch (getCurrentTemplate()) {
		case PAGE_LOGIN:
			navigation();
			loginLogic();
			break;
		case PAGE_LANGUAGE_SELECT:
			initLanguageSelector();
			navigation();
			break;
		case PAGE_MODELCATEGORY_SELECTION:
			initModelcategorySelectLogic();
			navigation();
			break;
		case PAGE_MODEL_SELECTION:
			initModelSelectLogic();
			navigation();
			break;
		case PAGE_PACKAGE_SELECTION:
			initPackageSelectionModal();
			initCheckBoxesLogic();
			navigation();
			break;
		case PAGE_FRONTSEAT_SELECTION:
			initSeatSelect();
			navigation();
			break;
		case PAGE_FRONTSEAT_CONFIGURATION:
			initSeatCustomizing();
			navigation();
			break;
		case PAGE_BACKSEAT_CONFIGURATION:
			initDots();
			initComponentsSeatsCustomizing();
			navigation();
			break;
		case PAGE_SITZBLENDE_CONFIGURATION:
			initDots();
			initLeatherCoverSelectLogic();
			navigation();
			break;
		case PAGE_WHEEL_SELECTION:
			initWheelSelectLogic();
			navigation();
			break;
		case PAGE_WHEEL_CONFIGURATION:
			initDots();
			initSteeringWheelCustomizing();
			navigation();
			break;
		case PAGE_AIRBAG_CONFIGURATION:
			initDots();
			initSteeringWheelCustomizing();
			initAirbagSelectLogic();
			navigation();
			break;
		case PAGE_RS_STICKUNG_CONFIGURATION:
			initRSStickungSelectLogic();
			navigation();
			break;
		case PAGE_RS_FOOTMATE_CONFIGURATION:
			navigation();
			initDots();
			initDisplayToggle();
			initInteriorFootmatsCustomizing();
			break;
		case PAGE_DECORATION_WOOD:
			initDots();
			initDisplayToggle();
			initDecoWoodSelectLogic();
			navigation();
			break;		
		case PAGE_SKY:
			initDots();
			initDisplayToggle();
			initSkySelectLogic();
			navigation();
			break;		
		case PAGE_BICOLOR:
			initDots();
			initDisplayToggle();
			initBicolorSelectLogic();
			navigation();
			break;			
		case PAGE_PILLOW:
			initDots();
			initPillowSelectLogic();
			navigation();
			break;		
		case PAGE_INTERIOR_LEATHER:
			initDots();
			initDisplayToggle();
			initInteriorLeatherSelectLogic();
			navigation();
			break;			
		case PAGE_INTERIOR:
			initDots();
			initInteriorCustomizing();
			navigation();
			initDisplayToggle();
			break;
		case PAGE_INTERIOR_FC1:
			initDots();
			initInteriorFC1Customizing();
			navigation();
			initDisplayToggle();
			break;
		case PAGE_INTERIOR_LEATHER_YZ4:
			initDots();
			initInteriorYZ4Customizing();
			navigation();
			initDisplayToggle();
			break;	
		case PAGE_PDF:
			initSummaryAndGeneratePDF();
			navigation();
			initValidation();
			saveMetaOnChange();
			break;
		case PAGE_INTERIOR_SEATBELTS:
			navigation();
			initDots();
			initDisplayToggle();
			initInteriorSeatBeltsCustomizing();
			break;
		case PAGE_INTERIOR_FOOTMAT:
			navigation();
			initDots();
			initDisplayToggle();
			initInteriorFootmatsCustomizing();
			break;
		case PAGE_INTERIOR_UPPER:
			navigation();
			initDots();
			initDisplayToggle();
			initInteriorUpperCustomizing();
			break;
		default:
			navigation();
			break;
	}
});

// Tooltip for color selection
document.addEventListener('DOMContentLoaded', function() {
	const colorSelections = document.querySelectorAll('.color-selection');
	colorSelections.forEach(function(selection) {
	  const labels = selection.querySelectorAll('label');
	  labels.forEach(function(label) {
		const imgsWithTitle = label.querySelectorAll('img[title]');
		let collectedTitles = [];
		imgsWithTitle.forEach(function(img) {
		  const titleValue = img.getAttribute('title');
		  if (titleValue) {
			collectedTitles.push(titleValue);
			img.removeAttribute('title');
		  }
		});
		if (collectedTitles.length > 0) {
		  const combinedTitle = collectedTitles[0];
		  label.setAttribute('data-tooltip', combinedTitle);
		  label.classList.add('tooltip-label');
		}
	  });
	});
});	  

function getCurrentTemplate() {
	return document.querySelector("body").dataset.template;
}